import questionTypes from '../questionTypes';

import getCommonBlockProps from './getCommonBlockProps';
import { STYLING_KEY_QUESTION_TEXT } from '../../constants/stylingKey';

export default {
  type: questionTypes.respondentCompanyName,
  getDefaultProps: () => ({
    ...getCommonBlockProps(),
    label: 'Company name',
  }),
  settings: {
    defaultStylingEntity: STYLING_KEY_QUESTION_TEXT,
    isUniqueField: () => true,
    isRequiredField: () => false,
    isTextRequired: () => false,
  },
};
